import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 8px;
  padding-top: 6px;
  border-top: 1px dashed ${({ theme }) => theme.colors.gray30};

  && span.label {
    font-size: 1.1rem !important;
    color: ${({ theme }) => theme.colors.success};
  }
`

export const IconWrapper = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  border-radius: 6px;
  background: ${({ theme }) => `${theme.colors.success}1a`};
  display: flex;
  align-items: center;
  justify-content: center;

  svg.icon {
    width: 13px !important;
    height: 13px !important;
    color: ${({ theme }) => theme.colors.success};
  }
`
